<template>
  <b-container>
    <b-row>
      <b-col>
        <page-content-creator
          :itemid="itemid"
          pos="top"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <page-content-creator
          :itemid="itemid"
          pos="top"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <node-element-local-tasks
          v-if="itemid"
          :itemid="itemid"
        />
        <div
          v-if="notpublished"
          class="messages warning"
        >Not published</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="faq">
          <h4 class="faq-category">
            {{ category }}
          </h4>
          <h2 class="faq-title">
            {{ title }}
          </h2>
          <page-content-wysiwg-content
            class="faq-body"
            :item="item"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <page-content-creator
          :itemid="itemid"
          pos="bottom"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { asyncLoader, pageMixin } from '../page-content-type-wines-faq-common'

let title = ''

export default {
  name: 'page-content-type-wine_faq',
  asyncData: (args) => asyncLoader(args),
  mixins: [
    pageMixin
  ],
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.faq {
  margin: 3em 0;
  .faq-title {
    margin-bottom: 1em;
  }
  .faq-category {
    opacity: 0.6;
  }
}

</style>
